<div class="stepper-wrapper" *ngIf="!isNestedStepper; else nestedStepper">
	<div class="row mb-3" *ngIf="messageInfo?.showMessage && !data?.isRequirmentsFormReadOnly">
		<div class="col-md-12" id="fading-div">
			<div class="custom-alert custom-alert-info">
				{{ 'forms.common.stepper.' + messageInfo?.message | translate }}
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-3 div-border">
			<ul class="list-unstyled list-group">
				<li
					(click)="onSelectStep(ind, item, true)"
					*ngFor="let item of stepperMenu; let ind = index"
					[ngClass]="{
						margin: ind === 0,
						active: activeStep == ind
					}"
					[ngStyle]="{
						color:
							(item.status && item.status === TABSTATUS.COMPLETED && (isBOView || isFOView)) ||
							(!item.status && item.submitted && item.submitted == true && isFOView)
								? '#28a745'
								: item.status && item.status === TABSTATUS.NOTCOMPLETED && (isBOView || isFOView)
								? '#9d2929'
								: '#343a40'
					}"
					class="list-group-item external h5"
				>
					<span
						*ngIf="
							(item.status && item.status === TABSTATUS.COMPLETED && (isBOView || isFOView)) ||
							(!item.status && item.submitted && item.submitted == true && isFOView)
						"
						class="span-margin"
					>
						<mat-icon class="m-3">check_circle</mat-icon>
					</span>
					<span
						*ngIf="item.status && item.status === TABSTATUS.NOTCOMPLETED && (isBOView || isFOView)"
						class="span-margin"
					>
						<mat-icon class="m-3">cancel</mat-icon>
					</span>
					<span
						*ngIf="(!item.submitted && isFOView) || (!item.status && isBOView)"
						class="list-number custom-margin"
						>{{ ind + 1 }}.</span
					>
					<span>{{ 'forms.common.stepper.' + item.formKey | translate }}</span>
				</li>
			</ul>
		</div>
		<div class="col-9 div-border">
			<formio-loader></formio-loader>
			<formio
				#form
				*ngIf="formReady"
				[showLoader]="false"
				[readOnly]="data?.isRequirmentsFormReadOnly"
				[formKey]="currentForm?.formKey"
				[submission]="formSubmission"
				(formLoad)="formLoad($event)"
				(customEvent)="customSave($event)"
			>
			</formio>

			<!-- [submission]="{ data: { parentRoute: parentRoute } }" -->
			<formio
				#decisionsForm
				*ngIf="decisionsFormReady"
				[formKey]="summaryResourceKey"
				[showLoader]="false"
				[readOnly]="false"
				[submission]="{ data: decisionsFormSubmission }"
				[submissionId]="currentForm?.summarySubmissionId"
				(submissionLoad)="onLoadDecisions($event)"
				(submit)="afterDecisionSubmitted($event)"
			>
			</formio>

			<div *ngIf="formReady && !formioLoader?.loading" class="d-block mb-3 text-center">
				<button
					(click)="
						activeStep > 0 ? (activeStep = activeStep - 1) : 0;
						onSelectStep(activeStep, stepperMenu[activeStep])
					"
					[disabled]="!(activeStep > 0)"
					class="btn custom-btn btn-wizard-nav-previous"
					style="border-radius: 45px !important"
					[pTooltip]="'forms.common.stepper.previous' | translate"
					tooltipPosition="top"
				>
					<mat-icon>{{ dir === 'rtl' ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
				</button>
				<button
					(click)="
						activeStep < stepperMenu.length - 1
							? (activeStep = activeStep + 1)
							: stepperMenu.length - 1;
						onSelectStep(activeStep, stepperMenu[activeStep])
					"
					[disabled]="!(activeStep < stepperMenu.length - 1)"
					class="btn custom-btn btn-wizard-nav-next"
					style="border-radius: 45px !important"
					[pTooltip]="'forms.common.stepper.next' | translate"
					tooltipPosition="top"
				>
					<mat-icon>{{ dir === 'rtl' ? 'arrow_back' : 'arrow_forward' }}</mat-icon>
				</button>
			</div>
		</div>
	</div>
</div>

<ng-template #nestedStepper>
	<div class="stepper-wrapper top">
		<div class="row">
			<div class="col-12 div-border">
				<ul class="list-unstyled list-group list-group-horizontal">
					<li
						(click)="onSelectStep(ind, item, true)"
						*ngFor="let item of stepperMenu; let ind = index"
						[ngClass]="{
							active: activeStep == ind
						}"
						[ngStyle]="{
							color:
								(item.status && item.status === TABSTATUS.COMPLETED && (isBOView || isFOView)) ||
								(!item.status && item.submitted && item.submitted == true && (isBOView || isFOView))
									? '#28a745'
									: item.status && item.status === TABSTATUS.NOTCOMPLETED && (isBOView || isFOView)
									? '#9d2929'
									: '#343a40'
						}"
						class="internal"
						[pTooltip]="'forms.common.stepper.' + item.formKey | translate"
						tooltipPosition="top"
					>
						<span *ngIf="!item.status && item.submitted && item.submitted == true && isFOView">
							<mat-icon>check_circle</mat-icon>
						</span>
						<span *ngIf="item.status && item.status === TABSTATUS.NOTCOMPLETED && isFOView">
							<mat-icon>cancel</mat-icon>
						</span>
						<div *ngIf="(!item.submitted && !item.status) || isBOView" class="list-number">
							{{ ind + 1 }}
						</div>
						<!-- <span>{{ 'forms.common.stepper.' + item.formKey | translate }}</span> -->
					</li>
				</ul>
			</div>
		</div>

		<div class="row">
			<div class="col-12 div-border">
				<formio-loader></formio-loader>
				<formio
					#form
					*ngIf="formReady"
					[showLoader]="false"
					[readOnly]="data?.isRequirmentsFormReadOnly"
					[formKey]="currentForm?.formKey"
					[submission]="formSubmission"
					(customEvent)="customSave($event)"
				>
				</formio>

				<!-- [submission]="{ data: { parentRoute: parentRoute } }" -->
				<formio
					#nestedDecisionsForm
					*ngIf="decisionsFormReady"
					[formKey]="summaryResourceKey"
					[showLoader]="false"
					[readOnly]="false"
					[submission]="{ data: decisionsFormSubmission }"
					[submissionId]="currentForm?.summarySubmissionId"
					(submissionLoad)="onLoadDecisions($event)"
					(submit)="afterDecisionSubmitted($event)"
				>
				</formio>

				<div *ngIf="formReady && !formioLoader?.loading" class="d-block mb-3 text-center">
					<button
						(click)="
							activeStep > 0 ? (activeStep = activeStep - 1) : 0;
							onSelectStep(activeStep, stepperMenu[activeStep])
						"
						[disabled]="!(activeStep > 0)"
						class="btn custom-btn btn-wizard-nav-previous"
						style="border-radius: 45px !important"
						[pTooltip]="'forms.common.stepper.previous' | translate"
						tooltipPosition="top"
					>
						<mat-icon>{{ dir === 'rtl' ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
					</button>
					<button
						(click)="
							activeStep < stepperMenu.length - 1
								? (activeStep = activeStep + 1)
								: stepperMenu.length - 1;
							onSelectStep(activeStep, stepperMenu[activeStep])
						"
						[disabled]="!(activeStep < stepperMenu.length - 1)"
						class="btn custom-btn btn-wizard-nav-next"
						style="border-radius: 45px !important"
						[pTooltip]="'forms.common.stepper.next' | translate"
						tooltipPosition="top"
					>
						<mat-icon>{{ dir === 'rtl' ? 'arrow_back' : 'arrow_forward' }}</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>
